const packageName: string = process.env._PACKAGE_NAME_ ?? '';
const packageVersion: string = process.env._PACKAGE_VERSION_ ?? '';

export { packageName, packageVersion };
